import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { retry } from "helpers/application"

import Shipping from "./shipping"

const InventoryTableModal = loadable(
  () => retry(() => import("areas/product/jewlr/modals/inventory-table-modal")),
  { ssr: false }
)
const ShippingInformationHalfModal = loadable(
  () => retry(() => import("areas/product/jewlr/modals/shipping-information")),
  { ssr: false }
)

const InternalShippingInfo = ({ outOfStock }) => {
  if (outOfStock) return null

  return (
    <>
      <InventoryTableModal />
      <ShippingInformationHalfModal />
      <Shipping />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    outOfStock: state.wizard.header?.product_out_of_stock,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalShippingInfo.propTypes = {
  outOfStock: PropTypes.bool,
}

const ShippingInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalShippingInfo)

export default ShippingInfo
